module.exports = __webpack_public_path__ + "img/Time.d8edd299.svg";